import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllProdiDropdown = createAsyncThunk(
  "prodi/GetAllProdiDropdown",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/prodi/get_by_fakultas_id/${data.id}`
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllProdi = createAsyncThunk(
  "prodi/GetAllProdi",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/prodi/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleProdi = createAsyncThunk(
  "prodi/GetSingleProdi",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/prodi/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateProdi = createAsyncThunk(
  "prodi/CreateProdi",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/prodi`,
        {
          kode: data.kode,
          nama: data.nama,
          id_fakultas: data.id_fakultas,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditProdi = createAsyncThunk(
  "prodi/EditProdi",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/prodi/${data.id}`,
        {
          kode: data.kode,
          nama: data.nama,
          id_fakultas: data.id_fakultas,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteProdi = createAsyncThunk(
  "prodi/DeleteProdi",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/prodi/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(`${api}master/prodi/all?${data.url}`, {
          headers: {
            Authorization: data.token,
          },
        });

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const prodiSlice = createSlice({
  name: "prodi",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all prodi dropdown
    builder.addCase(GetAllProdiDropdown.pending, loadingHandler);
    builder.addCase(GetAllProdiDropdown.fulfilled, fulfilledHandler);
    builder.addCase(GetAllProdiDropdown.rejected, rejectedHandler);
    // get all prodi
    builder.addCase(GetAllProdi.pending, loadingHandler);
    builder.addCase(GetAllProdi.fulfilled, fulfilledHandler);
    builder.addCase(GetAllProdi.rejected, rejectedHandler);
    // get Single prodi
    builder.addCase(GetSingleProdi.pending, loadingHandler);
    builder.addCase(GetSingleProdi.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleProdi.rejected, rejectedHandler);
    // create prodi
    builder.addCase(CreateProdi.pending, loadingHandler);
    builder.addCase(CreateProdi.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateProdi.rejected, rejectedHandler);
    // edit prodi
    builder.addCase(EditProdi.pending, loadingHandler);
    builder.addCase(EditProdi.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditProdi.rejected, rejectedHandler);
    // delete prodi
    builder.addCase(DeleteProdi.pending, loadingHandler);
    builder.addCase(DeleteProdi.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isDelete: true });
    });
    builder.addCase(DeleteProdi.rejected, rejectedHandler);
  },
});

export const { reset } = prodiSlice.actions;
export default prodiSlice.reducer;
